<template>
  <div class="relative py-4">
    <vs-row class="flex items-center mb-4 gap-4">
      <div v-if="!!title && titleType === 'small'" style="font-weight: 500; font-size: 14px">{{ title }}</div>
      <div v-if="!!title && titleType === 'tooltip'" class="flex">
        <h5 v-html="title" />
        <vx-tooltip :title="tooltipHead" :html="tooltipBody" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
          <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px; color: #7e72f2" @click="onClickToolTip()" />
        </vx-tooltip>
      </div>
      <h5 v-else-if="!!title" class="flex items-center"><i class="dot" v-if="titleType !== 'noCircle'"></i>{{ title }}</h5>
      <div v-else></div>
      <div v-if="controls && !board.readonly && !isPrint" class="ml-auto">
        <slot name="headButton"/>
        <vs-button v-if="isAddRow" color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button v-if="isRemoveRow" class="ml-4" color="secondary" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </vs-row>

    <table :class="[thema === 'label' && 'label-table']">
      <colgroup>
        <col v-if="multiple && !isPrint && !board.readonly" width="60" />
        <template v-for="(col, col_i) in tableData" >
          <col v-if="col.type === 'risk'" :key="`col_${col_i}_${col.id}_0`" :width="col.width" class="xl:table-column" :class="[isPrint ? 'table-column' : 'hidden']" />
          <col v-if="col.type === 'risk'" :key="`col_${col_i}_${col.id}_1`" :width="col.width" class="xl:table-column" :class="[isPrint ? 'table-column' : 'hidden']" />
          <col v-if="col.type === 'risk'" :key="`col_${col_i}_${col.id}_2`" :width="col.width" class="xl:table-column" :class="[isPrint ? 'table-column' : 'hidden']" />
          <col v-else :key="`col_${col_i}_${col.id}`" :width="col.width" class="xl:table-column" :class="[mobile.includes(col.id)||isPrint ? 'table-column' : 'hidden']" />
        </template>
        <col v-if="!isPrint" width="60" class="xl:hidden" />
      </colgroup>
      <thead>

      <tr>
        <th v-if="multiple && !isPrint && !board.readonly" rowspan="2">
          <vs-checkbox :value="checkData.length === list.length && 0 < list.length" class="justify-center mx-0" @click.native="onClickAllCheckbox" />
        </th>
        <th :style="{ 'border-bottom' : isPrint? 'none' : ''}" v-for="th in tableData" :key="th.id" class="xl:table-cell" :class="[mobile.includes(th.id)||isPrint ? 'table-cell' : 'hidden']" :rowspan="th.type ==='risk'? 1 : 2" :colspan="th.type === 'risk' ? 3 : 1">
          <div class="w-full text-center">{{ th.title }}</div>
        </th>
        <th v-if="!isPrint" class="xl:hidden"></th>
      </tr>
      <tr :class="isMobile && !isPrint ? 'hidden': 'table-row'">
        <th :style="{ 'border' : isPrint? 'none' : ''}">
          <div class="flex justify-center">
            가능성
            <vx-tooltip title="가능성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
            <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px; color: #7e72f2" @click="onClickToolTip1()" />
          </vx-tooltip>
          </div>
        </th>
        <th :style="{ 'border' : isPrint? 'none' : ''}">
          <div class="flex justify-center">
            중대성
            <vx-tooltip title="중대성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
              <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px; color: #7e72f2" @click="onClickToolTip2()" />
            </vx-tooltip>
          </div>
        </th>
        <th :style="{ 'border' : isPrint? 'none' : ''}">
          <div class="flex justify-center">
            위험도
            <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
              <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px; color: #7e72f2" @click="onClickToolTip3()" />
            </vx-tooltip>
          </div>
        </th>
      </tr>
      </thead>
      <tbody v-for="(tr, indextr) in list" :key="indextr">
      <tr :style="{ 'z-index': list.length - indextr }" style="box-shadow: none !important; transform: translateY(0px)" class="print-container relative">
        <td v-if="multiple && !isPrint && !board.readonly">
          <vs-checkbox v-model="checkData" :vs-value="tr.id" class="justify-center mx-0" />
        </td>
        <template v-for="cellData in tableData">
          <td v-if="cellData.type === 'risk'"
              class="text-center"
              :class="isMobile && !isPrint ? 'hidden': 'table-cell'"
              style="vertical-align: top;">
            <div>
              <p v-if="isPrint" class="w-full flex-1 text-center print-input"> {{tr.risk1}} </p>
              <vs-select v-else class="w-full" autocomplete v-model="tr.risk1" @change="handleChangeinput(indextr, tr)">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber1" />
              </vs-select>
            </div>
          </td>
          <td v-if="cellData.type === 'risk'"
              class="text-center"
              :class="isMobile && !isPrint ? 'hidden': 'table-cell'"
              style="vertical-align: top;">
            <div>
              <p v-if="isPrint" class="w-full flex-1 text-center print-input"> {{tr.risk2}} </p>
              <vs-select v-else class="w-full" autocomplete v-model="tr.risk2" @change="handleChangeinput(indextr, tr)">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber1" />
              </vs-select>
            </div>
          </td>
          <td v-if="cellData.type === 'risk'"
              class="text-center"
              :class="isMobile && !isPrint ? 'hidden': 'table-cell'"
              style="vertical-align: top;">
            <div>
              <p v-if="isPrint" class="w-full flex-1 text-center print-input"> {{tr.risk3}} </p>
              <ml-input :readonly="true" class="w-full text-center" v-model="tr.risk3" v-else :style="{ color: tr.riskColor }" />
            </div>
          </td>
          <td
            v-if="cellData.type !== 'risk'"
            :key="cellData.id"
            class="text-center"
            :class="getItemBodyClass(cellData)"
            :colspan="cellData.type === 'risk' ? 3 : 1"
            style="vertical-align: top;"
          >
            <div v-if="cellData.type === 'no'" :style="{ textAlign: cellData.align }">
              {{ indextr + 1 }}
            </div>
            <div v-else-if="cellData.type === 'label'" :style="{ textAlign: cellData.align }">
              {{ tr[cellData.id] }}
            </div>
            <div v-else @click.stop>
              <!-- Print -->
              <span v-if="isPrint && cellData.type === 'textarea'" class="print-textarea">
                {{ tr[cellData.id] }}
              </span>
              <span v-else-if="isPrint && cellData.type === 'dateArr'"> {{ tr[cellData.id].sDate }} ~ {{ tr[cellData.id].eDate }} </span>
              <div v-else-if="isPrint && cellData.type === 'customType'">
                <slot name="customType" :index="indextr" :cellData="cellData" :trData="tr" :value="tr[cellData.id]" :input="(data) => customTypeInput(indextr, cellData.id, data)"></slot>
              </div>
              <div v-else-if="isPrint">
                <div v-if="cellData.type !== 'sign'" class="print-input">
                  {{ tr[cellData.id] }}
                </div>
                <div v-else style="text-align: -webkit-center">
                  <img v-if="tr[cellData.id]" :src="tr[cellData.id]" alt="Signature" class="signatureImg" />
                  <div v-else style="width: 100%; height: 80px; min-width: 80px; max-width: 120px" class="print-input"></div>
                </div>
              </div>
              <!-- Content -->
              <div v-else>
                <div v-if="cellData.type === 'string'" :style="{ textAlign: cellData.align }" v-html="tr[cellData.id]"></div>
                <ml-input v-else-if="cellData.type === 'text'" :readonly="board.readonly || cellData.readonly" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                <ml-input v-else-if="cellData.type === 'valueText'" :readonly="board.readonly || cellData.readonly" :value="cellData.value" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                <slot v-else-if="cellData.type === 'calcul'" name="calcul" v-bind:data="tr" v-bind:data_i="indextr"></slot>
                <ml-input v-else-if="cellData.type === 'fixed-text'" :readonly="true" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                <comma-input v-else-if="cellData.type === 'number'" :readonly="board.readonly" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                <ml-textarea
                  v-if="cellData.type === 'textarea'"
                  height="90px"
                  :readonly="board.readonly || cellData.readonly"
                  v-model="tr[cellData.id]"
                  :placeholder="typeof cellData.placeholder === 'string' ? cellData.placeholder : cellData.placeholder[indextr]"
                  class="w-full flex-1 resize-none"
                  @click.stop
                />
                <ml-input v-else-if="cellData.type === 'select' && board.readonly" v-model="tr[cellData.id]" readonly class="w-full flex-1" />
                <ml-input v-else-if="cellData.type === 'select' && tr[cellData.id] === '직접입력'" @blur="(e, data) => customSelectBlur(indextr, cellData.id, data)" class="w-full flex-1" :renderFocus="true" />
                <vs-select v-else-if="cellData.type === 'select'" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" autocomplete>
                  <vs-select-item v-for="selectData in cellData.selectData" :key="selectData" :text="selectData" :value="selectData" />
                </vs-select>
                <date-selector v-else-if="cellData.type === 'date'" class="w-full" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
                <time-selector v-else-if="cellData.type === 'time'" class="w-full" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
                <period-picker v-else-if="cellData.type === 'period'" v-model="tr[cellData.id]" :readonly="board.readonly" />
                <CompanySelector v-else-if="cellData.type === 'company'" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
                <field-selector v-else-if="cellData.type === 'field'" v-model="tr[cellData.id]" :readonly="board.readonly" />
                <div v-else-if="cellData.type === 'dateArr' && !!tr[cellData.id]" class="flex flex-col">
                  <date-selector v-model="tr[cellData.id].sDate" placeholder="시작일" :readonly="board.readonly"></date-selector>
                  <span class="px-3">~</span>
                  <date-selector v-model="tr[cellData.id].eDate" placeholder="종료일" :readonly="board.readonly"></date-selector>
                </div>
                <sign-field v-else-if="cellData.type === 'sign'" v-model="tr[cellData.id]" :readonly="board.readonly" />
                <div v-else-if="cellData.type === 'radio'" class="flex justify-center items-center gap-3">
                  <vs-radio v-for="(radioItem, radioItem_i) in cellData.radioItems" :key="`${indextr}_${radioItem_i}`" v-model="tr[cellData.id]" :vs-name="`${indextr}_${radioItem_i}`" :vs-value="radioItem.value">
                    {{ radioItem.label || radioItem.value }}
                  </vs-radio>
                </div>
                <div v-else-if="cellData.type === 'customType'">
                  <slot name="customType" :index="indextr" :cellData="cellData" :trData="tr" :value="tr[cellData.id]" :isMobile="isMobile" :input="(data) => customTypeInput(indextr, cellData.id, data)"></slot>
                </div>
              </div>
            </div>
          </td>
        </template>
        <!-- Mobile -->
        <td v-if="!isPrint" class="xl:hidden text-base text-center py-4" v-for="(mobileData, mobileData_i) in mobile" :key="`${mobileData}_${mobileData_i}`">
          {{ tr[mobileData] }}
        </td>
        <td v-if="!isPrint" class="xl:hidden" @click="openMobile(indextr)">
          <img src="@/assets/icons/triangle_down.svg" class="mx-auto duration-200" :style="{ transform: tr.open ? 'rotate(180deg)' : 'rotate(0deg)' }" />
        </td>
      </tr>
      <!-- MobileTab -->
      <tr v-if="!isPrint" v-show="tr.open" class="xl:hidden">
        <td :colspan="mobile.length + (multiple && !isPrint && !board.readonly ? 2 : 1)" class="py-4 px-3">
          <div class="writeGridContainer mb-0">
            <div v-for="cellData in tableData" :key="cellData.id" v-show="cellData.type !== 'no' && cellData.type !== 'label'">
              <div>{{ cellData.title }}</div>
              <ml-input v-if="cellData.type === 'text'" :readonly="board.readonly" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
              <ml-input v-else-if="cellData.type === 'fixed-text'" :readonly="true" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
              <comma-input v-else-if="cellData.type === 'number'" :readonly="board.readonly" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
              <ml-textarea v-else-if="cellData.type === 'textarea'" height="90px" :readonly="board.readonly" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1 mb-0" @click.stop />
              <ml-input v-else-if="cellData.type === 'select' && board.readonly" v-model="tr[cellData.id]" readonly class="w-full flex-1" />
              <ml-input v-else-if="cellData.type === 'select' && tr[cellData.id] === '직접입력'" @blur="(e, data) => customSelectBlur(indextr, cellData.id, data)" class="w-full flex-1" :renderFocus="true" />
              <vs-select v-else-if="cellData.type === 'select'" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" autocomplete>
                <vs-select-item v-for="selectData in cellData.selectData" :key="selectData" :text="selectData" :value="selectData" />
              </vs-select>
              <date-selector v-else-if="cellData.type === 'date'" class="w-full" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
              <time-selector v-else-if="cellData.type === 'time'" class="w-full" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
              <period-picker v-else-if="cellData.type === 'period'" v-model="tr[cellData.id]" :readonly="board.readonly" />
              <CompanySelector v-else-if="cellData.type === 'company'" v-model="tr[cellData.id]" :readonly="board.readonly" @click.stop />
              <sign-field v-else-if="cellData.type === 'sign'" v-model="tr[cellData.id]" :readonly="board.readonly" />
              <div v-else-if="cellData.type === 'risk'">
                <div class="grid mb-2" style="grid-template-columns: 88px 1fr; align-items: center;">
                  <p>가능성</p>
                  <vs-select class="w-full" autocomplete v-model="tr.risk1" @change="handleChangeinput(indextr, tr)">
                    <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber1" />
                  </vs-select>
                </div>
                <div class="grid mb-2" style="grid-template-columns: 88px 1fr; align-items: center;">
                  <p>중대성</p>
                  <vs-select class="w-full" autocomplete v-model="tr.risk2" @change="handleChangeinput(indextr, tr)">
                    <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber1" />
                  </vs-select>
                </div>
                <div class="grid" style="grid-template-columns: 88px 1fr; align-items: center;">
                  <p>위험도</p>
                  <ml-input :readonly="true" class="w-full text-center" v-model="tr.risk3" :style="{ color: tr.riskColor }" />
                </div>
              </div>
              <div v-else-if="cellData.type === 'customType'">
                <slot name="customType" :index="indextr" :cellData="cellData" :trData="tr" :value="tr[cellData.id]" :input="(data) => customTypeInput(indextr, cellData.id, data)"></slot>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
      <tbody>
      <slot name="customTr"></slot>
      </tbody>
    </table>

    <vs-popup id="popupRiskInfo" :title="popupHead" :active.sync="showInfoPopup">
      <div style="padding: 16px">
        <span v-html="popupBody" />
      </div>
    </vs-popup>

    <popup-risk-info_3x3_1 v-model="showInfoPopup1" />
    <popup-risk-info_3x3_2 v-model="showInfoPopup2" />
    <popup-risk-info_3x3_3 v-model="showInfoPopup3" />
  </div>
</template>

<script>
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PeriodPicker from "@/components/PeriodPicker.vue";
import PopupRiskInfo_3x3_1 from "@/components/TableRiskAppraisal_3x3/PopupRiskInfo_3x3_1.vue";
import PopupRiskInfo_3x3_2 from "@/components/TableRiskAppraisal_3x3/PopupRiskInfo_3x3_2.vue";
import PopupRiskInfo_3x3_3 from "@/components/TableRiskAppraisal_3x3/PopupRiskInfo_3x3_3.vue";

export default {
  name: "TableRiskAssemblyRecord",
  components: {
    PopupRiskInfo_3x3_1,
    PopupRiskInfo_3x3_2,
    PopupRiskInfo_3x3_3,
    PeriodPicker,
    TimeSelector,
    DateSelector,
    SignField,
    CompanySelector,
    FieldSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    controls: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    thema: {
      type: String,
      default: "default",
    },
    title: String,
    titleType: String,
    // 팝업관련
    tooltipHead: String,
    tooltipBody: String,
    popupHead: String,
    popupBody: String,
    tableData: Array,
    value: Array,
    maxSize: {
      type: Number,
      default: 0,
    },
    mobile: {
      type: Array,
      default: () => [],
    },
    // 직접 추가 버튼을 제어할 경우 TRUE
    customAddHandler: {
      type: Boolean,
      default: false,
    },
    isValueConvert: {
      type: Boolean,
      default: false,
    },
    isAddRow: {
      type: Boolean,
      default: true,
    },
    isRemoveRow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
  },
  data() {
    return {
      checkData: [],
      list: this.value,
      dateArrCheck: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
      showInfoPopup: false,
      showInfoPopup1: false,
      showInfoPopup2: false,
      showInfoPopup3: false,
      optionsNumber1: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
      optionsNumber2: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // 추가버튼때 데이터를 넣기위해 dateArr의 id 값을 찾는다.
    this.dateArrCheck = this.tableData.map((td) => {
      if (td.type === "dateArr") return td.id;
    });
  },
  methods: {
    getItemBodyClass(cellData) {
      let classNames = "";
      if (cellData.type === 'no' || cellData.type === 'label' || cellData.type === 'string' || cellData.middle) {
        classNames += 'align-center'
      } else {
        classNames += 'align-top'

        if (this.isPrint) {
          classNames += ' table-cell'
        } else {
          classNames += ' hidden xl:table-cell'
        }
      }
      return classNames;
    },

    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow() {
      if (this.customAddHandler) {
        this.$emit("add-row", ++this.numberId);
        return;
      }

      if (this.maxSize > 0) {
        if (this.list.length >= this.maxSize) {
          alert(`${this.maxSize}개 이하로 입력이 가능합니다.`);
          return;
        }
      }

      const addData = { id: ++this.numberId, risk1: "-", risk2: "-", risk3: "" };
      if (0 < this.dateArrCheck.length) {
        this.dateArrCheck.map((_adc) => {
          addData[_adc] = {};
        });
      }
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },

    openMobile(indextr) {
      const target = this.list[indextr];
      this.$set(target, "open", !!target.open ? !target.open : true);
    },

    customTypeInput(index, key, data) {
      this.$set(this.list[index], key, data);
    },

    // Select 직접입력
    customSelectBlur(index, key, data) {
      this.$set(this.list[index], key, "");
      this.$nextTick(() => {
        this.$set(this.list[index], key, data);
      });
    },

    // tooltip
    onClickToolTip() {
      this.showInfoPopup = true;
    },

    onClickToolTip1() {
      this.showInfoPopup1 = true;
    },
    onClickToolTip2() {
      this.showInfoPopup2 = true;
    },
    onClickToolTip3() {
      this.showInfoPopup3 = true;
    },
    handleChangeinput(index, tr) {
      if (tr.risk1 === "-" || tr.risk2 === "-") {
        tr.risk3 = "";
        return;
      }

      const value = tr.risk1 * tr.risk2;
      tr.riskColor = this.riskColor(value);
      tr.risk3 = this.convertValue(value);
    },
    riskColor(value) {
      if (value >= 1 && value <= 2) {
        return "#28C76F";
      } else if (value >= 3 && value <= 4) {
        return "#FF8510";
      } else {
        return "#E42728";
      }
    },
    convertValue(value) {
      if (this.isValueConvert) {
        if (value >= 1 && value <= 2) {
          return "낮음";
        } else if (value >= 3 && value <= 4) {
          return "보통";
        } else {
          return "높음";
        }
      }

      return value;
    }
  },
};
</script>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    background: #f9f9f9;
    z-index: 0 !important;

    th {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #3c3c3c;

      border-top: solid 1px #cdcdcd;
      border-bottom: solid 1px #cdcdcd;
      padding: 16px 0;
    }
  }
  tbody {
    tr {
      background: #fff !important;
      border-bottom: solid 1px #cdcdcd;

      td {
        padding: 6px;
      }
    }
  }
}

table.label-table {
  @media (min-width: theme("screens.xl")) {
    &,
    tr,
    th,
    td {
      border: 1px solid #cdcdcd;
    }
    td {
      padding: 4px !important;
    }

    thead {
      th {
        background: #f9f9f9;
      }
    }
  }
}
.signatureImg {
  border: 1px solid #00000033;
  border-radius: 6px;
  min-height: 80px;
  max-width: 120px;
}

div::v-deep .input-span-placeholder {
  text-align: left;
}

div::v-deep .input-select::placeholder,
div::v-deep textarea::placeholder {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 300;
}
</style>
